module.exports = __webpack_public_path__ + "img/users.70a31bf0.svg";